import request from '../utils/request'

// ==================== 用户管理 ====================

// 获取用户列表
export function getUserList(params) {
  return request({
    url: '/system.user_controller/list',
    method: 'get',
    params
  })
}

// 获取用户详情
export function getUserDetail(params) {
  return request({
    url: '/system.user_controller/detail',
    method: 'get',
    params
  })
}

// 创建用户
export function createUser(data) {
  return request({
    url: '/system.user_controller/create',
    method: 'post',
    data
  })
}

// 更新用户
export function updateUser(data) {
  return request({
    url: '/system.user_controller/update',
    method: 'post',
    data
  })
}

// 删除用户
export function deleteUser(data) {
  return request({
    url: '/system.user_controller/delete',
    method: 'post',
    data
  })
}

// 重置用户密码
export function resetUserPassword(data) {
  return request({
    url: '/system.user_controller/resetPassword',
    method: 'post',
    data
  })
}

// 更新用户状态
export function updateUserStatus(data) {
  return request({
    url: '/system.user_controller/updateStatus',
    method: 'post',
    data
  })
}

// 分配用户角色
export function assignUserRoles(data) {
  return request({
    url: '/system.user_controller/assignRoles',
    method: 'post',
    data
  })
}

// 获取用户角色
export function getUserRoles(params) {
  return request({
    url: '/system.user_controller/getRoles',
    method: 'get',
    params
  })
}

// ==================== 角色管理 ====================

// 获取角色列表
export function getRoleList(params) {
  return request({
    url: '/system.role_controller/list',
    method: 'get',
    params
  })
}

// 获取角色详情
export function getRoleDetail(params) {
  return request({
    url: '/system.role_controller/detail',
    method: 'get',
    params
  })
}

// 创建角色
export function createRole(data) {
  return request({
    url: '/system.role_controller/create',
    method: 'post',
    data
  })
}

// 更新角色
export function updateRole(data) {
  return request({
    url: '/system.role_controller/update',
    method: 'post',
    data
  })
}

// 删除角色
export function deleteRole(data) {
  return request({
    url: '/system.role_controller/delete',
    method: 'post',
    data
  })
}

// 分配角色权限
export function assignRolePermissions(data) {
  return request({
    url: '/system.role_controller/assignPermissions',
    method: 'post',
    data
  })
}

// 获取角色权限
export function getRolePermissions(params) {
  return request({
    url: '/system.role_controller/getPermissions',
    method: 'get',
    params
  })
}

// ==================== 权限管理 ====================

// 获取权限列表（树形结构）
export function getPermissionList(params) {
  return request({
    url: '/system.permission_controller/list',
    method: 'get',
    params
  })
}

// 获取权限详情
export function getPermissionDetail(params) {
  return request({
    url: '/system.permission_controller/detail',
    method: 'get',
    params
  })
}

// 创建权限
export function createPermission(data) {
  return request({
    url: '/system.permission_controller/create',
    method: 'post',
    data
  })
}

// 更新权限
export function updatePermission(data) {
  return request({
    url: '/system.permission_controller/update',
    method: 'post',
    data
  })
}

// 删除权限
export function deletePermission(data) {
  return request({
    url: '/system.permission_controller/delete',
    method: 'post',
    data
  })
}

// ==================== 部门管理 ====================

// 获取部门列表（树形结构）
export function getDepartmentList(params) {
  return request({
    url: '/system.department_controller/list',
    method: 'get',
    params
  })
}

// 获取部门详情
export function getDepartmentDetail(params) {
  return request({
    url: '/system.department_controller/detail',
    method: 'get',
    params
  })
}

// 创建部门
export function createDepartment(data) {
  return request({
    url: '/system.department_controller/create',
    method: 'post',
    data
  })
}

// 更新部门
export function updateDepartment(data) {
  return request({
    url: '/system.department_controller/update',
    method: 'post',
    data
  })
}

// 删除部门
export function deleteDepartment(data) {
  return request({
    url: '/system.department_controller/delete',
    method: 'post',
    data
  })
}

// 获取部门用户
export function getDepartmentUsers(params) {
  return request({
    url: '/system.department_controller/getUsers',
    method: 'get',
    params
  })
}

// ==================== 日志管理 ====================

// 获取操作日志列表
export function getOperationLogList(params) {
  return request({
    url: '/system.log_controller/operationList',
    method: 'get',
    params
  })
}

// 获取操作日志详情
export function getOperationLogDetail(params) {
  return request({
    url: '/system.log_controller/operationDetail',
    method: 'get',
    params
  })
}

// 获取登录日志列表
export function getLoginLogList(params) {
  return request({
    url: '/system.log_controller/loginList',
    method: 'get',
    params
  })
}

// 获取登录日志详情
export function getLoginLogDetail(params) {
  return request({
    url: '/system.log_controller/loginDetail',
    method: 'get',
    params
  })
}

// 清空操作日志
export function clearOperationLog(data) {
  return request({
    url: '/system.log_controller/clearOperationLog',
    method: 'post',
    data
  })
}

// 清空登录日志
export function clearLoginLog(data) {
  return request({
    url: '/system.log_controller/clearLoginLog',
    method: 'post',
    data
  })
}

// 导出操作日志
export function exportOperationLog(params) {
  return request({
    url: '/system.log_controller/exportOperationLog',
    method: 'get',
    params,
    responseType: 'blob'
  })
}

// 导出登录日志
export function exportLoginLog(params) {
  return request({
    url: '/system.log_controller/exportLoginLog',
    method: 'get',
    params,
    responseType: 'blob'
  })
}

// ==================== 字典管理 ====================

// 获取字典类型列表
export function getDictTypeList(params) {
  return request({
    url: '/system.dict_controller/typeList',
    method: 'get',
    params
  })
}

// 获取字典数据列表
export function getDictDataList(params) {
  return request({
    url: '/system.dict_controller/dataList',
    method: 'get',
    params
  })
}

// 创建字典类型
export function createDictType(data) {
  return request({
    url: '/system.dict_controller/createType',
    method: 'post',
    data
  })
}

// 更新字典类型
export function updateDictType(data) {
  return request({
    url: '/system.dict_controller/updateType',
    method: 'post',
    data
  })
}

// 删除字典类型
export function deleteDictType(data) {
  return request({
    url: '/system.dict_controller/deleteType',
    method: 'post',
    data
  })
}

// 创建字典数据
export function createDictData(data) {
  return request({
    url: '/system.dict_controller/createData',
    method: 'post',
    data
  })
}

// 更新字典数据
export function updateDictData(data) {
  return request({
    url: '/system.dict_controller/updateData',
    method: 'post',
    data
  })
}

// 删除字典数据
export function deleteDictData(data) {
  return request({
    url: '/system.dict_controller/deleteData',
    method: 'post',
    data
  })
}